// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"144":"52c3f522","377":"52c3f522","816":"52c3f522"}[chunkId] + ".chunk.css";
};